export default __webpack_public_path__ + "static/media/appIcon.52e05ff4.svg";